<template>
  <CBox v-if="doctor" display="flex" flexDirection="column">
    <OmtRow>
      <CFlex>
        <CBox mr="2">
          <OmtIcons
            name="user-doctor"
            p="8px"
            backgroundColor="var(--colors-light-primary-light-gray)"
            borderRadius="8px"
            h="32px"
            w="32px"
            size="1x"
            display="flex"
            justify-content="center"
            align-items="center"
          />
        </CBox>
        <CFlex width="80%" mr="auto" align-items="center">
          <OmtTypography as="h1-bold" color="var(--colors-light-primary-navy-blue)">
            {{ doctor.DescricaoPrestador }}
          </OmtTypography>
        </CFlex>
        <CBox v-show="false" mr="4">
          <OmtIcons size="1x" name="share-nodes" />
        </CBox>
      </CFlex>
    </OmtRow>

    <omt-divider my="24px" />

    <OmtRow v-if="doctor.Distancia !== undefined && !Number.isNaN(doctor.Distancia)" mb="16px">
      <CBox>
        <CFlex align-items="center" mb="4px">
          <OmtIcons size="1x" name="location-dot" mr="2" />
          <OmtTypography as="h3-bold" color="#4A5E77">
            {{ distanciaFormatada }} km • A partir {{ locationTypeParse }}
          </OmtTypography>
        </CFlex>
        <OmtTypography color="#4A5E77" ml="20px" as="h3-bold" v-if="doctor.OrientacaoAtendimentoRede === 'S'">
          Rede Mediservice
        </OmtTypography>
      </CBox>
    </OmtRow>

    <OmtRow mb="4px" v-if="address1 !== ''">
      <CFlex>
        <OmtTypography as="p1" color="#4A5E77">{{ address1 }}</OmtTypography>
      </CFlex>
    </OmtRow>

    <OmtRow v-if="address2 !== ''">
      <CFlex>
        <OmtTypography as="p1" color="#4A5E77">{{ address2 }}</OmtTypography>
      </CFlex>
    </OmtRow>

    <OmtRow v-if="doctor.rating && false">
      <CFlex justifyContent="space-between">
        <CBox display="inline-flex" alignItems="center">
          <OmtIcons size="1x" prefix="fa-sharp" name="star" mr="2" color="var(--colors-light-support-warning)" />
          <OmtTypography as="h3-bold" color="var(--colors-light-support-warning)">{{ doctor.rating }}</OmtTypography>
        </CBox>
        <CBox v-if="doctor.totalReviews">
          <OmtTypography as="p1">{{ doctor.totalReviews }} avaliações</OmtTypography>
        </CBox>
      </CFlex>
    </OmtRow>

    <template v-if="contatos && contatos.length > 0">
      <omt-divider mt="24px" mb="24px" />

      <OmtRow mb="16px">
        <CFlex alignItems="center">
          <CBox mr="2">
            <OmtIcons
              size="1x"
              name="phone"
              p="8px"
              backgroundColor="var(--colors-light-primary-light-gray)"
              borderRadius="8px"
              h="32px"
              w="32px"
              display="flex"
              justify-content="center"
              align-items="center"
            />
          </CBox>
          <CBox mr="2">
            <OmtTypography as="button-medium" color="#4A5E77">Contatos</OmtTypography>
          </CBox>
        </CFlex>
      </OmtRow>

      <OmtRow>
        <CFlex flexDirection="column">
          <CFlex v-for="(contato, index) in contatos" :key="index" flexDirection="column" mb="16px">
            <OmtTypography as="p1" color="#4A5E77" lineHeight="26px">
              {{ formatarTelefone(contato) }}
            </OmtTypography>
            <OmtTypography v-if="contato.WhatsApp" as="p1" color="#4A5E77" lineHeight="20px">
              Atende por WhatsApp
            </OmtTypography>
          </CFlex>
        </CFlex>
      </OmtRow>
    </template>

    <OmtRow v-if="exibirWazeMaps" :mt="contatos && contatos.length === 0 ? '24px' : '0px'">
      <CFlex width="100%" flexDirection="['column', 'row']">
        <CFlex
          :width="['100%', '206px']"
          height="32px"
          :mr="['0px', '24px']"
          py="10px"
          border="1px solid var(--colors-light-secondary-divider)"
          borderRadius="0px"
          justifyContent="center"
          alignItems="center"
          cursor="pointer"
          @click="goTo(`https://www.google.com/maps/search/?api=1&query=${doctor.GmLatitude}%2C${doctor.GmLongitude}`)"
        >
          <img :src="googleMaps" />
        </CFlex>
        <CFlex
          :width="['100%', '206px']"
          height="32px"
          py="10px"
          border="1px solid var(--colors-light-secondary-divider)"
          bgColor="#15CCFF"
          borderRadius="0px"
          justifyContent="center"
          alignItems="center"
          cursor="pointer"
          @click="goTo(`https://www.waze.com/ul?ll=${doctor.GmLatitude}%2C${doctor.GmLongitude}&navigate=yes&zoom=17`)"
        >
          <img :src="waze" />
          <img :src="wazeIcon" />
        </CFlex>
      </CFlex>
    </OmtRow>

    <template v-if="doctor.Especialidades && doctor.Especialidades.length > 0">
      <omt-divider mt="24px" mb="24px" />
      <OmtRow mb="16px">
        <CFlex alignItems="center">
          <CBox mr="2">
            <OmtIcons
              size="1x"
              name="user-doctor"
              p="8px"
              backgroundColor="var(--colors-light-primary-light-gray)"
              borderRadius="8px"
              h="32px"
              w="32px"
              display="flex"
              justify-content="center"
              align-items="center"
            />
          </CBox>
          <CBox mr="2">
            <OmtTypography as="button-medium" color="#4A5E77">Especialidades</OmtTypography>
          </CBox>
        </CFlex>
      </OmtRow>

      <OmtRow>
        <CFlex>
          <CList styleType="disc" pl="8px">
            <CListItem v-for="(e, i) in doctor.Especialidades" :key="`spec-${i}`">
              <OmtTypography as="p1" display="inline-flex" color="#4A5E77">
                {{ e.DescricaoEspecialidade.trim() }}
              </OmtTypography>
            </CListItem>
          </CList>
        </CFlex>
      </OmtRow>
    </template>

    <template v-if="doctor.Formacao && doctor.Formacao.length > 0">
      <omt-divider mt="24px" mb="24px" />

      <OmtRow mb="16px">
        <CFlex alignItems="center">
          <CBox mr="2">
            <OmtIcons
              size="1x"
              name="file-certificate"
              p="8px"
              backgroundColor="var(--colors-light-primary-light-gray)"
              borderRadius="8px"
              h="32px"
              w="32px"
              display="flex"
              justify-content="center"
              align-items="center"
            />
          </CBox>
          <CBox mr="2">
            <OmtTypography as="button-medium" color="#4A5E77">Dados curriculares</OmtTypography>
          </CBox>
        </CFlex>
      </OmtRow>

      <OmtRow v-for="(c, i) in doctor.Formacao" :key="`cv-${i}`">
        <CBox :mb="i < doctor.Formacao.length - 1 ? '16px' : ''">
          <OmtTypography as="p1" v-if="c.Periodo" color="#4A5E77">
            <strong>{{ c.Periodo }}</strong>
          </OmtTypography>
          <OmtTypography as="p1" color="#4A5E77"> {{ c.Descricao }}</OmtTypography>
        </CBox>
      </OmtRow>
    </template>

    <template v-if="facilidades && facilidades.length > 0">
      <omt-divider mt="24px" mb="24px" />

      <OmtRow mb="16px">
        <CFlex alignItems="center">
          <CBox mr="2">
            <OmtIcons
              size="1x"
              name="check"
              p="8px"
              backgroundColor="var(--colors-light-primary-light-gray)"
              borderRadius="8px"
              h="32px"
              w="32px"
              display="flex"
              justify-content="center"
              align-items="center"
            />
          </CBox>
          <CBox mr="2">
            <OmtTypography as="button-medium" color="#4A5E77">Facilidades</OmtTypography>
          </CBox>
        </CFlex>
      </OmtRow>

      <OmtRow>
        <CFlex>
          <CList styleType="disc" pl="8px">
            <CListItem v-for="(e, i) in facilidades" :key="`acc-${i}`">
              <template v-if="e === teleconsulta">
                <CFlex display="inline-flex">
                  <OmtTypography display="inline-flex" as="p1">{{ e }}</OmtTypography>
                  <OmtIcons name="video" ml="12px" />
                </CFlex>
              </template>
              <OmtTypography v-else display="inline-flex" as="p1">{{ e }}</OmtTypography>
            </CListItem>
          </CList>
        </CFlex>
      </OmtRow>
    </template>

    <template v-if="idioms && idioms.length > 0">
      <omt-divider mt="24px" mb="24px" />

      <OmtRow mb="16px">
        <CFlex alignItems="center">
          <CBox mr="2">
            <OmtIcons
              size="1x"
              name="earth-americas"
              p="8px"
              backgroundColor="var(--colors-light-primary-light-gray)"
              borderRadius="8px"
              h="32px"
              w="32px"
              display="flex"
              justify-content="center"
              align-items="center"
            />
          </CBox>
          <CBox mr="2">
            <OmtTypography as="button-medium" color="#4A5E77">Idiomas</OmtTypography>
          </CBox>
        </CFlex>
      </OmtRow>

      <OmtRow>
        <CFlex>
          <CList styleType="disc" pl="8px">
            <CListItem v-for="(id, i) in idioms" :key="`lang-${i}`">
              <OmtTypography display="inline-flex" as="p1" color="#4A5E77">{{ id.trim() }}</OmtTypography>
            </CListItem>
          </CList>
        </CFlex>
      </OmtRow>
    </template>

    <omt-divider mt="24px" mb="24px" />

    <OmtRow mb="24px">
      <CFlex alignItems="center">
        <CBox mr="2">
          <OmtIcons
            size="1x"
            name="medal"
            p="8px"
            backgroundColor="var(--colors-light-primary-light-gray)"
            borderRadius="8px"
            h="32px"
            w="32px"
            display="flex"
            justify-content="center"
            align-items="center"
          />
        </CBox>
        <CBox mr="2">
          <OmtTypography as="button-medium" color="#4A5E77">Qualificações</OmtTypography>
        </CBox>
      </CFlex>
    </OmtRow>

    <OmtRow mb="24px">
      <CFlex>
        <CFlex
          v-if="doctor.Qualificacoes && doctor.Qualificacoes.length > 0"
          w="100%"
          p="16px"
          bg="var(--colors-light-primary-light-gray)"
          border-radius="8px"
          justify-content="center"
        >
          <CFlex v-for="(q, i) in doctor.Qualificacoes" :key="'qap-' + i" align-items="center">
            <CBox v-if="i > 0" m="-8px 16px" h="22px" border-left="1px solid var(--colors-light-secondary-divider)" />
            <img :src="q.UrlIconeImagem" :alt="q.CodigoIcone" v-chakra max-w="30px" max-h="16px" />
          </CFlex>
        </CFlex>
        <CBox w="100%" v-else p="10px 30px 10px 8px" bg="var(--colors-light-primary-light-gray)" border-radius="8px">
          <OmtTypography as="h3-semi-bold" color="#4A5E77">Qualificações não informadas pelo Prestador.</OmtTypography>
        </CBox>
      </CFlex>
    </OmtRow>

    <OmtRow mb="24px">
      <CBox>
        <OmtTypography as="p1" color="#4A5E77">
          Conforme Instrução Normativa 52/DIDES de 21/03/2013 a qualificação é uma informação voluntaria do Prestador
        </OmtTypography>
      </CBox>
    </OmtRow>

    <OmtRow mb="40px">
      <CBox class="qualifications-grid" :display="['none', 'grid']">
        <CFlex v-for="(q, i) in qualificacoesANS" :key="'qaa-' + i" align-items="center">
          <img :src="q.src" :alt="q.name" />
          <OmtTypography ml="2" as="p1" color="#4A5E77">{{ q.dsc }}</OmtTypography>
        </CFlex>
      </CBox>
      <CFlex :display="['flex', 'none']">
        <CList>
          <CListItem
            v-for="(q, i) in qualificacoesANS"
            :key="'qaa-' + i"
            display="inline-flex"
            w="100%"
            :pb="i < qualificacoesANS.length - 1 ? '16px' : ''"
          >
            <img :src="q.src" :alt="q.name" />
            <OmtTypography ml="2" as="p1" color="#4A5E77">{{ q.dsc }}</OmtTypography>
          </CListItem>
        </CList>
      </CFlex>
    </OmtRow>

    <OmtRow mb="24px">
      <CFlex pb="4" justifyContent="center">
        <OmtButton
          pt="12px"
          pb="12px"
          :w="['100%', '256px']"
          height="32px"
          @click="() => showPlansAttended()"
          borderRadius="0px"
        >
          <OmtTypography as="h3-bold" color="#FFF">Consultar planos atendidos</OmtTypography>
        </OmtButton>
      </CFlex>
    </OmtRow>
  </CBox>
</template>

<script>
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { isMobile } from "@/utils/utils";
import { mapGetters, mapActions, mapState } from "vuex";

export default {
  name: "DoctorDetail",
  data() {
    return {
      pictures: []
    };
  },
  async mounted() {
    this.$root.$emit("show-loading");
    try {
      const codigoPrestador = this.$route.params.CodigoPrestador || this.selectedProvider.CodigoPrestador;
      const srEndereco = this.$route.params.srEndereco || "";

      if (!codigoPrestador) {
        this.$router.replace({ name: "network.accredited.list" });
        return;
      }

      if (!this.selectedProvider) {
        this.$router.replace({ name: "network.accredited.list" });
        return;
      }

      await this.detalhePrestadorAnonimo({
        codigoPrestador,
        srEndereco,
        completo: true
      });

      if (!this.doctorDetail) {
        this.$router.replace({ name: "network.accredited.list" });
        return;
      }

      this.loadPictures();
    } catch (error) {
      console.error("Erro ao carregar detalhes do médico:", error);
      this.$router.replace({ name: "network.accredited.list" });
    } finally {
      this.$root.$emit("hide-loading");
    }
  },
  computed: {
    ...mapState("openNetworkSearch", ["doctorDetail", "selectedProvider"]),
    ...mapGetters("saude", ["baseUrl"]),
    doctor() {
      return {
        ...this.selectedProvider,
        ...this.doctorDetail
      };
    },
    exibirWazeMaps() {
      return (
        this.doctor?.GmLatitude &&
        this.doctor?.GmLongitude &&
        this.doctor?.GmLongitude !== "" &&
        this.doctor?.GmLatitude !== ""
      );
    },
    distanciaFormatada() {
      return this.doctor?.Distancia ? `${Math.round(this.doctor.Distancia * 100) / 100}`.replaceAll(".", ",") : "";
    },
    teleconsulta() {
      return "Atende também por teleconsulta";
    },
    googleMaps() {
      return process.env.VUE_APP_BASE_URL + "images/omint/google-maps.png";
    },
    waze() {
      return process.env.VUE_APP_BASE_URL + "images/omint/waze.png";
    },
    wazeIcon() {
      return process.env.VUE_APP_BASE_URL + "images/omint/waze-icon.png";
    },
    locationTypeParse() {
      return "da sua localização atual";
    },
    address1() {
      if (!this.doctor?.TipoLogradouro) return "";
      return `${this.doctor.TipoLogradouro.trim()} ${this.doctor.EnderecoRua.trim()}, ${this.doctor.EnderecoNumero.trim()}`;
    },
    address2() {
      if (!this.doctor?.TipoLogradouro) return "";
      return `${this.doctor.EnderecoBairro.trim()} - ${this.doctor.EnderecoCidade.trim()} - ${this.doctor.CodigoEstado.trim()}`;
    },
    facilidades() {
      const acessos = [];
      if (this.doctor?.Acessos?.length) acessos.push(...this.doctor.Acessos);
      if (this.doctor?.Teleconsulta && !acessos.find(a => a.toUpperCase().includes("TELECONSULTA")))
        acessos.push(this.teleconsulta);
      return acessos;
    },
    idioms() {
      if (!this.doctor?.Curriculo || this.doctor.Curriculo.length === 0) return [];
      let is = [];
      this.doctor.Curriculo.forEach(c => {
        if (c.Tipo === "Idiomas") {
          is = c.Registros;
          return is;
        }
      });
      return is;
    },
    qualificacoesANS() {
      const qa = [
        {
          name: "Aona",
          dsc: "Padrão nacional de qualidade",
          src: `${this.baseUrl}/images/omint/busca/aona.jpg`
        },
        {
          name: "Adicq",
          dsc: "Padrão nacional de qualidade",
          src: `${this.baseUrl}/images/omint/busca/adicq.jpg`
        },
        {
          name: "Apalc",
          dsc: "Padrão nacional de qualidade",
          src: `${this.baseUrl}/images/omint/busca/apalc.jpg`
        },
        {
          name: "Acba",
          dsc: "Padrão internacional de qualidade",
          src: `${this.baseUrl}/images/omint/busca/acba.jpg`
        },
        {
          name: "Aqg",
          dsc: "Padrão internacional de qualidade",
          src: `${this.baseUrl}/images/omint/busca/aqg.jpg`
        },
        {
          name: "R",
          dsc: "Profissional com residência",
          src: `${this.baseUrl}/images/omint/busca/r.jpg`
        },
        {
          name: "N",
          dsc: "Comunicação de eventos adversos",
          src: `${this.baseUrl}/images/omint/busca/n.jpg`
        },
        {
          name: "P",
          dsc: "Profissional com especialização",
          src: `${this.baseUrl}/images/omint/busca/p.jpg`
        },
        {
          name: "Q",
          dsc: "Qualidade monitorada",
          src: `${this.baseUrl}/images/omint/busca/q.jpg`
        },
        {
          name: "E",
          dsc: "Título de Especialista",
          src: `${this.baseUrl}/images/omint/busca/e.jpg`
        }
      ];
      return qa;
    },
    contatos() {
      return this.doctor?.Contatos || [];
    }
  },
  methods: {
    ...mapActions("openNetworkSearch", ["detalhePrestadorAnonimo"]),
    goTo(destiny) {
      window.open(destiny);
    },
    loadPictures() {
      // Implementar carregamento de fotos se necessário
      // Similar ao doctors-info.vue
    },
    async gotoSite(link) {
      if (!link) return;
      const yesOrNo = await Swal.fire({
        title: "Aviso",
        text: "Você será redirecionado para um site externo. Deseja continuar?",
        confirmButtonText: "Continuar",
        cancelButtonText: "Cancelar",
        showCancelButton: true
      });
      if (!yesOrNo.value) return;
      window.open(link, "_blank");
    },
    changeFavorite() {
      this.doctor.favorite = !this.doctor.favorite;
    },
    async redirectWhats(fone) {
      fone = fone.replaceAll("(", "");
      fone = fone.replaceAll(")", "");
      fone = fone.replaceAll("-", "");
      fone = fone.replaceAll(" ", "");
      const link = `https://wa.me/55${fone}`;
      if (isMobile) {
        window.location = `${link}?text=Ol%C3%A1`;
      } else {
        window.open(link, "_blank");
      }
    },
    async showPlansAttended() {
      await this.$router.push({
        name: "network.plans.served"
      });
    },
    formatarTelefone(contato) {
      const ddd = contato.EnderecoTelefoneDdd || "";
      const prefixo = contato.EnderecoTelefonePrefixo || "";
      const numero = contato.EnderecoTelefone || "";
      const extensao = contato.EnderecoExtensao || "";

      let telefone = `(${ddd}) ${prefixo}-${numero}`;

      if (extensao) {
        telefone += ` ramal ${extensao}`;
      }

      return telefone;
    }
  }
};
</script>

<style>
.doctor-item {
  color: #68788c;
  font-size: 14px;
}

.qualifications-grid {
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}
</style>
